export default {
  home: '首页',
  pageNotFound: '您要访问的页面不存在',
  backHome: '回首页',
  promo: '奖励',
  wallet: '充值',
  earn: '赚钱',
  me: '我的',
  loginRegister: '登录 / 注册',
  walletCenter: '充值中心',
  withdrawTitle: '提现',
  notice: '消息通知',
  support: '在线客服',
  back: '返回',
  close: '关闭',
  deposit: '充值',
  brand: 'BetCorgi',
  copySuccess: '已复制到剪贴板 · Copied',
  copyFailed: '复制失败，请手动复制',
  search: '搜索',
  /** 右下角主题浮标（演示） */
  theme: {
    menu: '主题 · 演示',
    aria: '主题切换 · 演示',
    title: '切换主题(演示)',
    darkPurple: '深紫',
    darkGold: '深金',
    lightGold: '白金',
    lightBlue: '白蓝',
  },
  /** 时间口径统一（规范 6.2）：今天 / 昨天、区间、站点时间提示、倒计时的唯一文案来源 */
  time: {
    /** 列表智能格式：今天 22:30 / 昨天 22:30（按设备日历） */
    today: '今天',
    yesterday: '昨天',
    /** 倒计时满一天的前缀：1天 02:03:04 */
    days: '{n}天',
    /** 筛选区间（按站点日界，与接口 time_range / period 同名） */
    range: {
      today: '今日',
      yesterday: '昨日',
      last_7d: '近 7 日',
      last_30d: '近 30 日',
      this_week: '本周',
      last_week: '上周',
      this_month: '本月',
      last_month: '上月',
    },
    siteTime: '站点时间',
    siteTimeWithOffset: '站点时间 {offset}',
    /** 设备时区 ≠ 站点时区时，出现在「今日 / 近 7 日 / 本月」筛选下方 */
    siteTimeHint: '按站点时间（{offset}）统计',
    /** 规则文案括注；后半句只在设备时区与站点时区不同时出现 */
    siteClockNote: '（站点时间 {offset}）',
    siteClockNoteLocal: '（站点时间 {offset}，即你当地 {local}）',
    /** 业务日（统计日等）原样显示时的标注 */
    siteDate: '站点日期',
    dailyReset: '每日 00:00{note}重置',
    resetIn: '距离重置',
    /** 有绝对到期时刻的：一天内倒计时，更久显示本地时刻 */
    expiresIn: '{countdown} 后过期',
    expiresAt: '{date} 过期',
    /** 等待时长（锁定 / 频控提示），分钟向上取整：1 小时 58 分 / 2 小时 / 58 分钟 */
    waitHm: '{h} 小时 {m} 分',
    waitH: '{h} 小时',
    waitM: '{m} 分钟',
    /** 充值渠道每日时段：09:00–23:00（站点时间 UTC-3） */
    dailyWindow: '{window}（{zone}）',
  },
}
